import { Box, Divider, Text } from "@chakra-ui/react";
import { FC } from "react";

import {
  FeatureCard,
  FeatureGrid,
  PageCta,
  PageHero,
  PageSection,
  SectionHeading,
  usePageTitle,
} from "./components";

export const OverOns: FC = () => {
  usePageTitle("Over ons");

  return (
    <Box>
      <PageHero
        title="Over BROSTAR"
        subtitle="Wij bouwen software waarmee bronhouders eenvoudig en betrouwbaar grondwaterdata kunnen aanleveren aan de Basisregistratie Ondergrond."
      />

      <PageSection>
        <SectionHeading>Onze missie</SectionHeading>
        <Box maxW="700px" mx="auto" textAlign="center" mb={16}>
          <Text fontWeight="400" fontSize="lg" color="gray.700" lineHeight="tall">
            BROSTAR maakt het aanleveren van grondwaterdata aan de BRO zo eenvoudig mogelijk. Na
            meermaals het wiel uitgevonden te hebben voor verschillende bronhouders leek het ons
            logischer om deze kennis in een generieke oplossing aan te bieden, om zo nog meer
            organisaties te kunnen bedienen. Wij geloven dat goede datakwaliteit begint bij
            gebruiksvriendelijke software, waar je zonder technische ervaring snel mee aan de slag
            kan.
          </Text>
        </Box>

        <Divider mb={16} />

        <SectionHeading>Wat we doen</SectionHeading>
        <FeatureGrid>
          <FeatureCard title="BRO-registraties vereenvoudigen">
            BROSTAR biedt een eenduidige interface voor alle BRO-domeinen. Gericht op het eenvoudig
            aanmaken en beheren van registraties in de Basisregistratie Ondergrond.
          </FeatureCard>
          <FeatureCard title="Data valideren voor aanlevering">
            We beperken de invoermogelijkheden, en geven aan welke waarden beschikbaar zijn in de
            Basisregistratie Ondergrond. Zo minimaliseert u verwerkingsfouten.
          </FeatureCard>
          <FeatureCard title="Bulk-leveringen">
            Voor leveringen die grotendeels hetzelfde zijn, of veel data bevatten, bieden we de
            mogelijkheid om Excel- en CSV-bestanden te uploaden, zodat u niet alles handmatig hoeft
            in te voeren. Hiermee is het mogelijk om alle grondwaterstanden van uw meetnet in één
            keer aan te leveren, zonder dat u hiervoor een koppeling hoeft te bouwen. Hetzelfde
            geldt voor een gehele kwaliteitsmeetronde.
          </FeatureCard>
          <FeatureCard title="Integraties">
            In onze samenwerking met verschillende bronhouders zijn er al diverse integraties
            ontwikkeld. Zo is het mogelijk om uw grondwaterstanden aan te leveren via: Lizard, FEWS
            of Wiski. Voor grondwatermonitorings buizen en netten hebben we ervaringen met
            verschillende GIS-Databases, Django-Applicaties of Excel-bestanden. Mocht u een
            specifieke integratie wensen, neem dan contact met ons op. We denken graag mee over de
            mogelijkheden.
          </FeatureCard>
          <FeatureCard title="Continue doorontwikkeling">
            Het platform wordt actief doorontwikkeld op basis van feedback van bronhouders en
            wijzigingen in de BRO-standaarden.
          </FeatureCard>
        </FeatureGrid>
      </PageSection>

      <PageSection>
        <Divider mb={16} />
        <SectionHeading>Het team</SectionHeading>
        <Box maxW="700px" mx="auto" textAlign="center">
          <Text fontWeight="400" color="gray.700" lineHeight="tall">
            BROSTAR wordt ontwikkeld door{" "}
            <Box
              as="a"
              href="https://www.nelen-schuurmans.nl"
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
              fontWeight="700"
            >
              Nelen &amp; Schuurmans
            </Box>
            , een Nederlands ingenieursbureau gespecialiseerd in waterbeheer en datagedreven werken.
            Ons team van ontwikkelaars en hydrologen werkt dagelijks aan het verbeteren van BROSTAR.
          </Text>
        </Box>
      </PageSection>

      <PageCta
        title="Klaar om te starten?"
        body="Meld u aan en begin vandaag met het eenvoudig aanleveren van uw grondwaterdata aan de BRO."
      />
    </Box>
  );
};
